import { createSlice } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const initialState = {
    sseConnectionOpen: false,
    currentPage: "home"
};
const applicationSlice = createSlice({
    name: 'application',
    initialState,
    reducers: {
        createPage: (state, { payload }) => {
            const pageId = v4();
            state.pages.push(Object.assign({ pageId }, payload));
        },
        createComponent: (state, { payload }) => {
            payload.component.name + '_' + v4();
            let page = state.pages.find((page) => page.pageId === payload.pageId);
            if (page) {
                page.components.push(payload.component);
            }
        },
        setProps: (state, { payload }) => {
            let page = state.pages.find((page) => page.pageId === payload.pageId);
            if (page) {
                page.components[payload.moduleId].props = Object.assign({}, payload.value);
            }
        },
        setClientId: (state, { payload }) => {
            state.clientId = payload;
        },
        setHeaders: (state, { payload }) => {
            state.headers = payload;
        },
        setSSEConnectionOpen: (state, { payload }) => {
            state.sseConnectionOpen = payload;
        }
    },
});
const selectSseConnectionOpen = (state) => state.Application.sseConnectionOpen;
// Action creators are generated for each case reducer function
const { createComponent, setProps, setClientId, setHeaders, setSSEConnectionOpen } = applicationSlice.actions;
var applicationReducer = applicationSlice.reducer;

export { applicationSlice, createComponent, applicationReducer as default, selectSseConnectionOpen, setClientId, setHeaders, setProps, setSSEConnectionOpen };
//# sourceMappingURL=applicationSlice.js.map
